import { render } from "./washingMachice.vue?vue&type=template&id=651fc83f&scoped=true"
import script from "./washingMachice.vue?vue&type=script&lang=js"
export * from "./washingMachice.vue?vue&type=script&lang=js"

import "./washingMachice.vue?vue&type=style&index=0&id=651fc83f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651fc83f"]])

export default __exports__